import { render, staticRenderFns } from "./index--tempfile.vue?vue&type=template&id=13187cc7&"
import script from "./index--tempfile.vue?vue&type=script&lang=js&"
export * from "./index--tempfile.vue?vue&type=script&lang=js&"
import style0 from "./index--tempfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports